import type { NestedValues } from "@/types/utils"

export const FILTERS = {
  projects: {
    index: () => "projects" as const,
  },
  surveys: {
    index: () => "surveys" as const,
  },
  tickets: {
    index: () => "tickets" as const,
  },
} as const

export type Filters = NestedValues<typeof FILTERS>
